import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthFetch } from '../hooks/useAuthFetch';
import { showSuccess, showError } from '../utils/toastUtils';
import '../stili/Eventi.css';

const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8080').replace(/\/$/, '');

export default function EventoForm() {
  const authFetch = useAuthFetch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    titolo: '',
    descrizione: '',
    dataEvento: '',
    luogo: '',
  });

  const formatToItalianDate = (isoDate) => {
    if (!isoDate) return '';
    const [year, month, day] = isoDate.split('-');
    return `${day}/${month}/${year}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === 'dataEvento' || name === 'descrizione' ? value : value.toUpperCase(),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        ...formData,
        titolo: (formData.titolo || '').trim(),
        descrizione: formData.descrizione || '',
        luogo: (formData.luogo || '').trim(),
      };

      const res = await authFetch(`${API_URL}/api/admin/eventi`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        let msg = `Errore durante la creazione dell'evento (${res.status})`;
        try {
          const err = await res.json();
          msg = err?.message || msg;
        } catch {}
        throw new Error(msg);
      }

      showSuccess('Evento creato con successo.');
      setFormData({
        titolo: '',
        descrizione: '',
        dataEvento: '',
        luogo: '',
      });
    } catch (err) {
      showError(err.message || "Errore durante la creazione dell'evento.");
    }
  };

  return (
    <div className="eventi-container" translate="no">
      <h2 className="eventi-title">Inserisci Nuovo Evento</h2>

      <div className="eventi-card">
        <div className="eventi-section">
          <h3 className="eventi-section-title">Dati evento</h3>

          <form onSubmit={handleSubmit}>
            <div className="eventi-grid-2">
              <div className="eventi-form-group">
                <label className="eventi-label">Titolo</label>
                <input
                  className="eventi-input"
                  type="text"
                  name="titolo"
                  value={formData.titolo}
                  onChange={handleChange}
                  required
                  placeholder="Titolo evento"
                />
              </div>

              <div className="eventi-form-group">
                <label className="eventi-label">Luogo</label>
                <input
                  className="eventi-input"
                  type="text"
                  name="luogo"
                  value={formData.luogo}
                  onChange={handleChange}
                  required
                  placeholder="Luogo evento"
                />
              </div>

              <div className="eventi-form-group">
                <label className="eventi-label">Data Evento</label>
                <input
                  className="eventi-input"
                  type="date"
                  name="dataEvento"
                  value={formData.dataEvento}
                  onChange={handleChange}
                  required
                />

                {formData.dataEvento && (
                  <p className="eventi-date-preview">
                    Data selezionata: <strong>{formatToItalianDate(formData.dataEvento)}</strong>
                  </p>
                )}
              </div>

              <div className="eventi-form-group eventi-full-width">
                <label className="eventi-label">Descrizione</label>
                <textarea
                  className="eventi-textarea"
                  name="descrizione"
                  value={formData.descrizione}
                  onChange={handleChange}
                  required
                  placeholder="Descrizione evento"
                />
              </div>
            </div>

            <div className="eventi-button-row">
              <button className="eventi-btn-primary" type="submit">
                Crea Evento
              </button>

              <button
                className="eventi-btn-secondary"
                type="button"
                onClick={() => navigate('/gestionale')}
              >
                Torna al Gestionale
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}